module.exports = __webpack_public_path__ + "img/Beginner-1.9628b16d.gif";